// @ts-nocheck
/* eslint-disable */
import { makeEvent } from "~/lib/signals";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { isDetailActive, isPhotoDetail } from "~/util/detail";
import { store } from "~/state/store";
import { htmlToImage } from "~/hti";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { detect } from "detect-browser";
import { node, icon } from "~/util/dom";
import { getWasmScreenshot } from "~/util/wasm";

(function() {
	const DEBUG = CONFIG.debugMode;
	const SKIP_SCREENSHOT = 0;

	/**
	 * Signaly:
	 * print-page - zacatek tisku
	 * print-done - konec tisku
	 */
	class Print {
		_wasmImageElem: HTMLImageElement;

		constructor() {
			this._printMode = 0;
			this._isPrinting = false;
			this._depends = [];

			this._renderPanoImage = null; //velký obrázek z panoramy
			this._wasmImageElem = null;

			// vlastni zachyceni ctrl+p
			document.addEventListener("keydown", this);
		}

		/**
		 * Ziskani modu tisku.
		 *
		 * @return {Number}
		 */
		get mode() {
			return this._printMode;
		}

		/**
		 * Tiskne se momentalne?
		 *
		 * @return {Boolean}
		 */
		get isPrinting() {
			return this._isPrinting;
		}

		/**
		 * Pridat zavislosti pro tisk.
		 *
		 * @param {Promise}  promise Pridat zavislost s promise
		 */
		addDepends(promise) {
			this._depends.push(promise);
		}

		handleEvent(e) {
			/* pokud uzivatel stisknul klavesovou zkratku pro tisk podstrcime mu nas tisk */
			if (this._isPrintShortCut(e) && !Mapy.getComponent("photoDetail").isActive() && !Mapy.getComponent("gallery").isActive()) {
				e.preventDefault();

				setTimeout(() => {
					this.print();
				}, 0);
			}
		}

		/**
		 * Priprava tisku - lze nastavit mod.
		 *
		 * @param {Number} printMode Mod
		 */
		prepare(printMode) {
			printMode = printMode || CONFIG.printMode || 0;

			if (typeof printMode === "string") {
				printMode = parseInt(printMode, 10);
			}

			//Mapy.getComponent("loader").start();

			Array.from(document.querySelectorAll(".noprint")).forEach(el => {
				el.style.setProperty("visibility", "hidden");
			});

			Array.from(document.querySelectorAll(".noprintdn")).forEach(el => {
				el.style.setProperty("display", "none");
			});

			Array.from(document.querySelectorAll(".print")).forEach(el => {
				el.style.setProperty("visibility", "visible");
			});

			if (window.devicePixelRatio > 1) {
				Array.from(document.querySelectorAll(".smap .tiles img")).forEach(el => {
					const srcset = el.srcset || "";
					const match = srcset.match(/([^ ]+) 2x/u);

					if (match) {
						el.src = match[1];
					}
				});
			}

			Mapy.getComponent("layout").setFullLogo(true);

			//chceme měřítko
			if (document.querySelector(".hud .scale")) {
				document.querySelector(".hud .scale").style.setProperty("visibility", "visible");
			}

			if (document.getElementById("route-results") && !Mapy.getComponent("print").isPrinting) {
				document.getElementById("route-results").classList.add("prnt");
			}

			this._printMode = printMode;
			makeEvent("print-page", this);
			//Mapy.getComponent("loader").end();
		}

		/**
		 * Hlavni funkce pro tisk.
		 *
		 * @param  {Object} optsArg Konfigurace
		 * @return {Promise}
		 */
		async print(optsArg) {
			const opts = {
				isPortrait: true,
				...optsArg,
			};

			this._isPrinting = true;
			this.prepare();

			try {
				if (this._depends.length) {
					await Promise.all(this._depends);
				}

				await this._print(opts);
			} catch (exc) {
				//
			}
		}

		/**
		 * Tisk - pokracovani.
		 *
		 * @param {Object} optsArg Konfigurace
		 * @param {Function}  resolve Z promise
		 */
		async _print(opts) {
			// init okna
			let docWin = this._initWindow(opts.isPortrait);

			if (!docWin) {
				return;
			}

			this._renderPanoImage = null;

			// hlavni obrazek - screenshot mapy nebo 3d
			const imgData = await this._mainImage();

			this._windowDone(docWin, imgData);
			this.returnAfterPrint();
			this._isPrinting = false;
		}

		/**
		 * Navrat do stavu po tisku.
		 */
		returnAfterPrint() {
			Array.from(document.querySelectorAll(".noprint")).forEach(el => {
				el.style.removeProperty("visibility");
			});

			Array.from(document.querySelectorAll(".noprintdn")).forEach(el => {
				el.style.display = "";
			});

			Array.from(document.querySelectorAll(".print")).forEach(el => {
				el.style.removeProperty("visibility");
			});

			if (document.getElementById("route-results")) {
				document.getElementById("route-results").classList.remove("prnt");
			}

			Mapy.getComponent("layout").setFullLogo();

			this._printMode = 0;
			this._depends.length = 0;

			if (this._wasmImageElem) {
				this._wasmImageElem.remove();
				this._wasmImageElem = null;
			}

			makeEvent("print-done", this);
		}

		/**
		 * Zjistuji zda uzivatel stisknul klavesouvou zkratku pro tisk (Ctrl + p)
		 *
		 * @param   {Event}  e
		 */
		_isPrintShortCut(e) {
			return (e.keyCode == 80 && (e.metaKey || e.ctrlKey) && !(e.altKey || e.shiftKey));
		}

		/**
		 * Priprava noveho okna.
		 *
		 * @param   {Boolean}  isPortrait  Jenda se o tisk na portret - vysku?
		 * @return  {Window}
		 */
		_initWindow(isPortrait) {
			// velikost
			let size = isPortrait ? `width=${(document.getElementById("mapycz").clientWidth + 30)}` : `height=${(document.getElementById("mapycz").clientHeight + 30)}`;

			// nastaveni okna
			let docWin = window.open("", "_blank", `menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,${size}`);

			if (!docWin || !docWin.document) {
				this.returnAfterPrint();
				this._isPrinting = false;
				Notifications.notify({
					content: _("print.popup"),
					type: NOTIFICATIONS_TYPE.ERROR
				});
				return null;
			}

			// titulek
			let title = document.title.replace("• ", "- ");
			if (title.length > 60) {
				title = `${title.substring(0, 30)} … ${title.substring(title.length - 24, title.length)}`;
			}

			// css
			let tmpCSS = Mapy.Util.node("div");
			const allLinks = Array.from(document.querySelectorAll("link[rel=stylesheet], style"));

			allLinks.forEach(el => {
				let cloneItem = el.cloneNode(true);
				if (cloneItem.href) {
					cloneItem.href += DEBUG ? Date.now().toString(16) : "p";
				}
				tmpCSS.appendChild(cloneItem);
			});

			// kostra
			docWin.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8" /><title>${title}</title>${tmpCSS.innerHTML}</head><body id="print-page" class="${document.body.className}"></body></html>`);

			if (DEBUG) {
				docWin.document.body.style.overflow = "auto";
			}

			// styl pro tiskovou stranku
			docWin.document.head.appendChild(Mapy.Util.node("link", {
				type: "text/css",
				rel: "stylesheet",
				href: `/css/printweb.${CONFIG.version}.css`,
			}, undefined, docWin.document));

			// zrušení formátování telefonních čísel (edge)
			docWin.document.head.appendChild(Mapy.Util.node("meta", {
				name: "format-detection",
				content: "telephone=no"
			}, undefined, docWin.document));

			// loader
			let loader = Mapy.Util.node("div", { id: "print-loader" }, undefined, docWin.document);
			let p = Mapy.Util.node("p", { innerHTML: `<img src="/img/loader.gif" /> ${_("print.wait")} &hellip;` }, undefined, docWin.document);
			loader.appendChild(p);

			docWin.document.body.appendChild(loader);

			return docWin;
		}

		/**
		 * Ziskani hlavni obrazku k vykresleni.
		 * Vraci promise se src pro obrazek.
		 */
		async _mainImage(): Promise<string> {
			if (SKIP_SCREENSHOT) {
				let canvas = document.createElement("canvas");
				let size = Scene.getSize();
				canvas.width = size.x;
				canvas.height = size.y;
				let ctx = canvas.getContext("2d");
				ctx.fillStyle = "green";
				ctx.fillRect(0, 0, size.x, size.y);

				return canvas.toDataURL();
			}

			//když mám aktivní galeri, nechceme obrázek
			if (Mapy.getComponent("gallery").isActive()) {
				return "";
			}

			if (Scene.isM3dActive()) {
				return Scene.get3dScreenshot(true).src;
			}

			// je panorama? udelame z webgl obrazek, jinak jedeme dal
			await this._panoImage();

			if (CONFIG.wasmEnabled) {
				await this._getWasmImage();
			}

			try {
				const imgData = await htmlToImage({
					element: document.getElementById("scene")
				});

				return imgData;
			} catch (exc) {
				//
			}

			return "";
		}

		/**
		 * Nastaveni dat pro screenshot panoramy.
		 *
		 * @return  {Promise}
		 */
		_panoImage() {
			return new Promise(resolve => {
				let pano = Mapy.getComponent("pano");

				if (pano.isActive()) {
					let panoCont = pano.getContainer();
					let canvas = panoCont.querySelector("canvas");
					const browser = detect();

					if (!canvas) {
						resolve();
					}
					else if (browser.name == "safari") {
						let panoState = pano.getState();
						let src = Mapy.Util.panoCompose(Object.assign(panoState, {
							width: Math.min(1500, canvas.offsetWidth),
							height: Math.min(1500, canvas.offsetHeight)
						}));

						let img = Mapy.Util.node("img", { id: "panoPrintImg", src: src, width: canvas.offsetWidth, height: canvas.offsetHeight, crossOrigin: "anonymous" });
						this._renderPanoImage = img;
						img.onload = () => {
							resolve();
						};
						img.onerror = () => {
							resolve();
						};
					}
					else {
						pano.getDataUrl().then(data => {
							let img = Mapy.Util.node("img", { id: "panoPrintImg", src: data, width: canvas.offsetWidth, height: canvas.offsetHeight });
							this._renderPanoImage = img;
							resolve();
						}, () => {});
					}
				}
				else {
					this._renderPanoImage = null;
					resolve();
				}
			});
		}

		async _getWasmImage() {
			const img = await getWasmScreenshot();

			if (img) {
				this._wasmImageElem = img;
			}
		}

		/**
		 * Priprava panelu pro nove okno.
		 * Vraci promise s elementem panelu.
		 *
		 * @return  {Element}
		 */
		_panel() {
			let panel = this._clearSearchLinks(document.getElementById("layout-scroll").cloneNode(true));
			panel.style.cssText = "";
			panel.querySelector("#layout-scroll #layout-body").style.cssText = "";

			let panorama = panel.querySelector("#layout-body #panorama");

			if (panorama) {
				panorama.remove();
			}

			if (Mapy.getComponent("route").isActive() && document.getElementById("route-results")) {
				panel.insertBefore(document.getElementById("route-results").cloneNode(true), panel.firstChild);
			}

			/* vyplnit gps inputy souradnicemi */
			let gps = panel.querySelector("#detail .modules .module-content .gps");
			if (gps) {
				gps.parentNode.classList.add("opened");

				Array.from(gps.parentNode.getElementsByTagName("input")).forEach(el => {
					el.setAttribute("value", el.value);
				});
			}

			/* tisknout parametry trasy, tisknout parametry trasy verejnou dopravoy */
			Array.from(panel.querySelectorAll("#route-form #route-type-box input", "#route-form #route-param-box input", "#route-form .pubt-container input[type=radio]")).forEach(el => {
				if (el.checked) {
					el.setAttribute("checked", "checked");
				}
			});

			let it = panel.querySelector("#route-form .pubt-container .time");
			if (it) {
				it.setAttribute("value", it.value);
			}

			let id = panel.querySelector("#route-form .pubt-container .date");
			if (id) {
				id.setAttribute("value", id.value);
			}

			let ui = panel.querySelector("#usermarks .edit input");
			if (ui) {
				ui.setAttribute("value", ui.value);
			}

			if (Mapy.getComponent("route").isActive() && panel.querySelector(".route-container")) {
				if (Mapy.CML.state.route?.items?.length == 0) {
					panel.querySelector(".route-container").remove();
				}
			}

			// canvas s 2d -> obrazky
			[".weather-graph canvas", ".line-chart canvas"].forEach(selector => {
				let panelEl = panel.querySelector(selector);
				let el = panelEl && document.querySelector(selector);

				if (el) {
					let img = Mapy.Util.node("img", { width: el.offsetWidth, height: el.offsetHeight, src: el.toDataURL() });
					img.style.display = "block";
					panelEl.parentNode.appendChild(img);
					panelEl.style.display = "none";
				}
			});

			//upravíme poilinky, aby ukazovaly plnou URL
			let poiLinks = panel.querySelectorAll(".content-link a");
			Array.from(poiLinks).forEach(link => {
				link.href = link.href.toString();
			});

			return panel;
		}

		/**
		 * Odstraneni veci z hledani pro tisk - nebyly k tomu komentare, moc nevim na co to je.
		 *
		 * @param   {Element}  node Panel
		 * @return  {Element}
		 */
		_clearSearchLinks(node) {
			if (node && node.querySelector("#search-results > ul")) {
				let lis = node.querySelectorAll("#search-results > ul > li");
				let links = document.querySelectorAll("#layout-scroll #search-results > ul > li > a.li-inner");

				if (lis.length == links.length) { // pojistka
					// zkopirujeme si obsah do noveho DIVu
					for (let i = 0; i < lis.length; i++) {
						let div = Mapy.Util.node("div", { className: "li-inner", innerHTML: links[i].innerHTML });
						lis[i].innerHTML = "";
						lis[i].appendChild(div);
					}
				}
			}

			return node;
		}

		/**
		 * Dokonceni vytvoreni okna a jeho naplneni.
		 *
		 * @param   {Window}  docWin   Hlavni objekt noveho okna
		 * @param   {String}  imgData  Hlavni data pro obrazek
		 */
		_windowDone(docWin, imgData) {
			const state = store.getState();
			let { title, panel = this._panel() } = Mapy.active[0].getPrintNodes();

			// post process
			let pano = Mapy.getComponent("pano");

			// zrusime loader
			let loader = docWin.document.getElementById("print-loader");
			loader?.remove();

			// js
			if (!DEBUG) {
				let script = Mapy.Util.node("script", { innerHTML: `(function() {
					window.addEventListener("load", function() {
						setTimeout(function() {
							window.print();
							window.open("","_self");
							window.close();
						}, 1000);
					});
				})();` }, undefined, docWin.document);
				docWin.document.body.appendChild(script);
			}

			let gallery = Mapy.getComponent("gallery");

			//speciální třída pro některé kontenty
			if (Mapy.getComponent("webcam").isActive()) { docWin.document.body.classList.add("webcam"); }
			if (pano.isActive()) { docWin.document.body.classList.add("pano"); }
			if (isPhotoDetail(state)) { docWin.document.body.classList.add("photodetail"); }
			if (gallery.isActive() && gallery.countPhotos() == 1) {
				docWin.document.body.classList.add("onephotogallery");
				let label = panel.querySelector("#gallery h4 label");
				if (label) {
					label.remove();
				}
			}

			let mapWrapper, photoImg, panoMapWraper;
			if (imgData || this._renderPanoImage) {
				// obal pro obrazek mapy a cokoliv (obvykle nadpis) pod nim
				mapWrapper = Mapy.Util.node("div", { id: "map-wrapper" }, undefined, docWin.document);

				// obrazek
				let imgCover = Mapy.Util.node("div", { id: "image" }, undefined, docWin.document);
				try {
					imgCover.appendChild(this._renderPanoImage ? this._renderPanoImage : Mapy.Util.node("img", { src: imgData, alt: "", id: "map-image" }, undefined, docWin.document));

					/*let container = node("span", { className: "control-mapy-logo logo-container print" });
					container.append(icon("logo"));

					imgCover.appendChild(container);*/
				} catch (err) {
					//ie, edge
					if (this._renderPanoImage) {
						imgCover.appendChild(Mapy.Util.node("img", { src: this._renderPanoImage.src, alt: "", id: "panoPrintImg" }, undefined, docWin.document));
					}
				}

				// obrazek k hlavnimu obrazku
				//nechci obrázek u fotodetailu
				if (!this._renderPanoImage && !isPhotoDetail(state)) {
					let imgNode = document.querySelector("#detail .content-poster > a img");
					if (imgNode) { photoImg = Mapy.Util.node("div", { className: "print-poster" }); photoImg.appendChild(imgNode.cloneNode(true)); }
				}

				mapWrapper.appendChild(imgCover);
				//mapa pro panoramu
				if (this._renderPanoImage && imgData) {
					if (!Scene.isM3dActive()) {
						panoMapWraper = Mapy.Util.node("div", { id: "pano-map" }, undefined, docWin.document);
						panoMapWraper.appendChild(Mapy.Util.node("img", { src: imgData, alt: "", id: "pano-map-image" }, undefined, docWin.document));
					} else {
						imgCover.innerHTML = "";
						imgCover.appendChild(Mapy.Util.node("img", { src: imgData, alt: "", id: "map-image" }, undefined, docWin.document));
					}
				}
			}
			// nadpis, pokud nejaky ma byt
			let titleContainer;
			if (title) {
				titleContainer = Mapy.Util.node("div", { className: "map-title", innerHTML: document.title }, undefined, docWin.document);
				titleContainer.innerHTML = title.outerHTML;
			}

			// panel
			let panelCover = Mapy.Util.node("div", { id: "panel" });
			panelCover.appendChild(panel);

			//pokud je hlavička (detailu, plachty JŘ), tak ji zopakujeme na druhé stránce
			let header, headSelector;
			if (isDetailActive(state) && !isPhotoDetail(state)) { headSelector = "#detail .header"; }

			if (headSelector) {
				header = panel.querySelector(headSelector);
				if (header && photoImg) {
					header.after(photoImg);
				}
			}

			if (mapWrapper) {
				docWin.document.body.appendChild(mapWrapper);
			}
			if (panoMapWraper) {
				docWin.document.body.appendChild(panoMapWraper);
			}
			if (titleContainer) {
				docWin.document.body.appendChild(titleContainer);
				if (photoImg) {
					titleContainer.after(photoImg);
				}
			}
			docWin.document.body.insertAdjacentHTML("beforeend", panelCover.outerHTML);

			if (isPhotoDetail(state) && mapWrapper) {
				let modules = docWin.document.body.querySelector("#detail .modules");
				if (modules) {
					modules.insertAdjacentElement("beforebegin", mapWrapper);
				}
			}

			// konec
			docWin.document.close();
		}
	}

	Mapy.Print = Print;
})();
